var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.facebookPostLink)?_c('div',{staticClass:"text-xs-center small my-4",staticStyle:{"font-size":"small"}},[_vm._v("\n  "+_vm._s(_vm.$t('This message was reply automatically.'))+"\n  "),_c('a',{attrs:{"href":_vm.facebookPostLink,"target":"_blank"}},[_vm._v("\n    "+_vm._s(_vm.$t('Go to post'))+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fdadc3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/livechat/LivechatFacebookPostLink.vue
// module id = null
// module chunks = 